import { AbstractControl, AsyncValidatorFn } from "@angular/forms";
import { map, of } from "rxjs";
import { SlotProductService } from "src/app/cabinet/services/slot-product.service";
import { IBaseGetByCabinetRequest, IBaseGetByProductRequest } from "src/app/core/models/base";

export function SlotProductValidator(slotProductService: SlotProductService, tenantId: string): AsyncValidatorFn {
    return  (control: AbstractControl) => {

        // Allow empty values
        if (!control.value) {
            return of(null);
        }

        // dont validate when not touched
        if(control.pristine){
            return of(null);
        }

        const productId = control.value;

        const request : IBaseGetByProductRequest = {
            pageNumber:0,
            pageSize: 999999,
            productId: productId,
            tenantId: tenantId
        }

        return slotProductService.getSlotProductsByProduct(request)
        .pipe(
            map(response => {
                const slotProducts = response.data;

                return slotProducts.length != 0 ? {nameIsNotUnique: true} : null;    
            })
        )
    }
}
